export class Documento {
  	_id: string;
	descripcion: string;
	nombre: string;
	estado: boolean;
	usuarioUltMdf: string;
	fechaUltMdf: Date;
    sucursal_id: string;
    usuariosNotificados: [string];
  logo:any;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/documento/documento.ts